import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import PowerBIEmbed from "./PowerBIEmbed";
import { useAuth } from "../contexts/AuthContext";

const Dashboard = () => {
  const { id, workspaceId } = useParams<{ id: string, workspaceId: string }>();
  const { loading: authLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      window.location.href = "/";
    }
  }, [isAuthenticated, authLoading]);

  return (
    <div className="page dashboard-page">
      <PowerBIEmbed reportKey={id!} workspaceId={workspaceId!} />
    </div>
  );
};

export default Dashboard;
